/**
 * Created by Carsten Bühler
 * User: c.buehler on 25.11.2016
 * Copyright: xdot GmbH 2015
 */

window[ 'req' + 'uire' ]([
        'alarmlevel-portlet/js/alarmlevel-portlet',
        'state-portlet/js/state-portlet'
    ],
    function () {
        console.info('Initial load of alarmlevel-portlet DONE!');
    },
    function (err) {
        console.error('Initial load of alarmlevel-portlet: ' + JSON.stringify(err.requireModules) + ' fail', err);
    }
);



// WEBPACK FOOTER //
// ./js/boot-alarmlevel.js